import styled from "styled-components";

import { handleTrackingButtonOnClick } from "./index";

const Button = ({ text, onClick, disabled, style }: any) => {
  return (
    <SButton
      onClick={() => handleTrackingButtonOnClick(text, onClick)}
      style={style}
      disabled={disabled}
    >
      {text}
    </SButton>
  );
};

export default Button;

const SButton = styled.button`
  width: 100%;
  height: 52px;

  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 16px;
  font-weight: 300;
  color: white;

  border-radius: 4px;
  border: none;

  color: ${(props) => (props.disabled ? "#b3b3b3" : "white")};
  background-color: ${(props) => (props.disabled ? "#e5e5e5" : "#0059d6")};
  cursor: ${(props) => (props.disabled ? "auto" : "pointer")};
`;
